import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Bell } from 'lucide-react';

const FEATURES = [
  { label: "Today's Class is Live", desc: "Know the moment a new class is posted for today" },
  { label: "New Classes Posted", desc: "New schedule available" },
  { label: "Class Starts in 30 Min", desc: "A check-in reminder — only for your booked classes" },
  { label: "Class Cancellations", desc: "Get notified if a class you booked gets cancelled (opt-in)" },
  { label: "Happy Birthday", desc: "A personal celebration from R&R on your big day" },
];

export default function NotificationAnnouncement({ open, onDismiss }) {
  const navigate = useNavigate();

  const markSeen = () => localStorage.setItem('notifications_feature_seen_v1', 'true');

  const handleSetup = () => {
    markSeen();
    onDismiss();
    navigate('/notifications');
  };

  const handleDismiss = () => {
    markSeen();
    onDismiss();
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="bg-[#18181B] border-[#27272A] max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        data-testid="notification-announcement-dialog"
      >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="bg-[#CCFF00]/10 p-3 rounded-sm">
              <Bell className="w-6 h-6 text-[#CCFF00]" />
            </div>
            <div>
              <p className="text-xs text-[#CCFF00] font-bold uppercase tracking-widest mb-0.5">
                What's New
              </p>
              <DialogTitle className="text-2xl font-heading font-black uppercase text-[#FAFAFA]">
                Push Notifications
              </DialogTitle>
            </div>
          </div>
          <DialogDescription className="text-[#A1A1AA]">
            Stay connected to R&R. Choose exactly which alerts you want on your device.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 space-y-2">
          {FEATURES.map(({ label, desc }) => (
            <div key={label} className="flex items-start gap-3 p-3 bg-[#09090B] rounded-sm">
              <span className="w-2 h-2 mt-1.5 bg-[#CCFF00] rounded-full shrink-0" />
              <div>
                <p className="text-sm text-[#FAFAFA] font-semibold">{label}</p>
                <p className="text-xs text-[#A1A1AA]">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex gap-3 mt-4">
          <Button
            onClick={handleDismiss}
            variant="outline"
            data-testid="notif-announcement-later-btn"
            className="flex-1 border-[#27272A] text-[#A1A1AA] hover:bg-[#27272A] uppercase tracking-wider rounded-sm"
          >
            Maybe Later
          </Button>
          <Button
            onClick={handleSetup}
            data-testid="notif-announcement-setup-btn"
            className="flex-1 bg-[#CCFF00] text-black font-bold uppercase tracking-wider hover:bg-[#B3E600] rounded-sm"
          >
            Set Up Now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
